import React from 'react'

import ModifyItemFooter from './ModifyItemFooter'
import ModifyItemPanels from './ModifyItemPanels'

import IconButton from '@material-ui/core/IconButton'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'

import { toast } from 'react-toastify'

class ModifyItem extends React.Component {

    notify = () => toast.info(this.state.item.Name + " was modified with success !")

    constructor(props) {
        super(props)
        this.state = {
            cartItem: [],
            item: [],
            quantity: 1,
            options: [],
            choice: [],
            notes: "",
            ingredients: [],
            totalOptions: 0,
            totalIngredients: 0
        }
    }

    componentDidMount() {

        let cartItem = this.props.cartItem
        this.setState({ cartItem })

    }

    addQuantity = () => {

        const cartItem = this.state.cartItem

        cartItem.quantity++
        cartItem.price = cartItem.originalPrice * cartItem.quantity

        this.setState({ cartItem })

    }

    removeQuantity = () => {

        const cartItem = this.state.cartItem

        if (cartItem.quantity > 1) {
            cartItem.quantity--
            cartItem.price = cartItem.originalPrice * cartItem.quantity
        }

        this.setState({ cartItem })

    }

    addOptions = (choice) => {

        console.log(choice)

        this.setState(state => ({
            options: state.options.includes(choice)
                ? state.options.filter(x => x !== choice)
                : [...this.state.options, choice]
        }),
            () => {
                this.setState({ totalOptions: this.state.options.reduce((sum, option) => sum + option.Price, 0) })
            }
        )
    }

    addIngredients = (ingredient) => {

        if (ingredient !== null) {
    
          let ingredients = [...this.state.ingredients]
          let ingredientIndex = this.state.ingredients.findIndex(ing => ing.Uid === ingredient.Uid)
    
          if (ingredientIndex === -1) {
    
            //Add Ingredient to Array
            ingredients = [...this.state.ingredients, ingredient]
    
          } else {
    
            if (ingredient.Value === null) {
              // Erase Ingredient
              ingredients.splice(ingredientIndex, 1)
            } else {
              // Update Ingredient
              ingredients[ingredientIndex] = ingredient
            }
    
          }
    
          this.setState({ ingredients },
            () =>
              this.setState({ totalIngredients: this.state.ingredients.reduce((sum, ingredient) => sum + ingredient.Price, 0) })
          )    
        }    
      }

    render() {

        const cartItem = this.state.cartItem
        let totalAmount = cartItem.quantity * (cartItem.itemPrice + this.state.totalIngredients + this.state.totalOptions);

        const styles = { marginLeft: -20 }

        if (cartItem.length === 0) {
            return (
                <>
                    <h3>Nothing here to edit...</h3>
                </>
            )
        }

        return (
            <>
                <AppBar position="static">
                    <Toolbar>
                        <IconButton style={styles} onClick={() => this.props.toggleDrawer()} color="inherit" aria-label="ArrowBackIcon">
                            <ArrowBackIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Card className="item_card">
                    <CardContent>
                        <Typography variant="h5" component="h2">
                            {cartItem.name}
                        </Typography>
                        <Typography className="title" color="textSecondary" gutterBottom>
                            {cartItem.Comment}
                        </Typography>
                        <Typography color="textSecondary" gutterBottom >
                            Price: {cartItem.itemPrice.toFixed(2)}$
                        </Typography>
                    </CardContent>
                </Card>

                <ModifyItemPanels
                    item={cartItem}
                    addOptions={this.addOptions.bind(this)}
                    addIngredients={this.addIngredients.bind(this)}
                />

                <ModifyItemFooter
                    quantity={cartItem.quantity}
                    addQuantity={this.addQuantity.bind(this)}
                    removeQuantity={this.removeQuantity.bind(this)}
                    totalAmount={totalAmount}
                />
            </>
        )
    }

}

export default ModifyItem